var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4370_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33349 10.9998C8.33349 10.0273 8.7198 9.0947 9.40743 8.40707C10.0951 7.71943 11.0277 7.33312 12.0002 7.33312H13.6668C14.635 7.33257 15.5636 6.94913 16.2502 6.26646L17.4168 5.09979C17.7576 4.75713 18.1627 4.4852 18.6089 4.29964C19.0551 4.11408 19.5336 4.01855 20.0168 4.01855C20.5001 4.01855 20.9786 4.11408 21.4248 4.29964C21.871 4.4852 22.2761 4.75713 22.6168 5.09979L23.7835 6.26646C24.4702 6.94979 25.4002 7.33312 26.3668 7.33312H28.0335C29.006 7.33312 29.9386 7.71943 30.6262 8.40707C31.3138 9.0947 31.7002 10.0273 31.7002 10.9998V12.6665C31.7002 13.6331 32.0835 14.5631 32.7668 15.2498L33.9335 16.4165C34.2762 16.7572 34.5481 17.1623 34.7336 17.6085C34.9192 18.0547 35.0147 18.5332 35.0147 19.0165C35.0147 19.4997 34.9192 19.9782 34.7336 20.4244C34.5481 20.8706 34.2762 21.2757 33.9335 21.6165L32.7668 22.7831C32.0842 23.4696 31.7007 24.3983 31.7002 25.3665V27.0331C31.7002 28.0056 31.3138 28.9382 30.6262 29.6258C29.9386 30.3135 29.006 30.6998 28.0335 30.6998H26.3668C25.3987 30.7003 24.47 31.0838 23.7835 31.7665L22.6168 32.9331C22.2761 33.2758 21.871 33.5477 21.4248 33.7333C20.9786 33.9188 20.5001 34.0144 20.0168 34.0144C19.5336 34.0144 19.0551 33.9188 18.6089 33.7333C18.1627 33.5477 17.7576 33.2758 17.4168 32.9331L16.2502 31.7665C15.5636 31.0838 14.635 30.7003 13.6668 30.6998H12.0002C11.0277 30.6998 10.0951 30.3135 9.40743 29.6258C8.7198 28.9382 8.33349 28.0056 8.33349 27.0331V25.3665C8.33294 24.3983 7.94949 23.4696 7.26682 22.7831L6.10016 21.6165C5.75749 21.2757 5.48556 20.8706 5.3 20.4244C5.11445 19.9782 5.01892 19.4997 5.01892 19.0165C5.01892 18.5332 5.11445 18.0547 5.3 17.6085C5.48556 17.1623 5.75749 16.7572 6.10016 16.4165L7.26682 15.2498C7.94949 14.5633 8.33294 13.6346 8.33349 12.6665V10.9998Z",
    fill: "#19BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19.0003L18.3333 22.3337L25 15.667",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4370_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.31fc67f51cb66a30de1b6bad2fe64147.svg";
export { ForwardRef as ReactComponent };